/* eslint-disable @typescript-eslint/no-explicit-any */
import { RichText, Campaign, Blog } from '@/payload-types'
import { IGraphQLResponse } from '@/types/graphql';
import { format } from 'date-fns'
import { getCollectionSpecificFields } from './fetchDataFromPayload';
import { postDataFields } from './queryFields/postFields';

function getH2Titles(richText: RichText) {
  const h2List = richText?.richText?.root?.children.filter((child) =>
    typeof child === 'object' &&
    child.tag === 'h2' &&
    child.hasOwnProperty('children') &&
    Array.isArray(child.children) &&
    child.children.some((x) => x.hasOwnProperty('text')));


  if (h2List != undefined && h2List?.length > 0) {
    const titles = h2List.flatMap((item) => {
      if (typeof item === 'object' && item.hasOwnProperty('children')) {
        if (Array.isArray(item.children)) {
          return item.children.flatMap((x) => {
            if (x.hasOwnProperty('text')) {
              return x.text
            }
          })
        }
      }
    })
    return titles[0];
  }
}

export function CreateAnchorLink(item: RichText | string, date?: string) {
  const title = typeof item === 'string' ? item : getH2Titles(item)

  if (title) {
    const href = title?.replace(/ /g, '-')
    const hrefLink = `#${href}`

    const formattedDate = date ? formatDateToMMDDYYYY(date) : null
    return { label: title ? title : '', href: hrefLink ? hrefLink : '', date: formattedDate }
  } else {
    return null
  }
}

const monthAbbreviations: { [key: number]: string } = {
  0: 'Jan.',
  1: 'Feb.',
  2: 'Mar.',
  3: 'Apr.',
  4: 'May',
  5: 'Jun.',
  6: 'Jul.',
  7: 'Aug.',
  8: 'Sept.',
  9: 'Oct.',
  10: 'Nov.',
  11: 'Dec.'
};

export function profileformatDate(dateString: string): string {
  const date = new Date(dateString);
  const month = date.getMonth();
  const day = date.getDate();
  const year = date.getFullYear();

  const monthAbbr = monthAbbreviations[month];
  return `${monthAbbr} ${day}, ${year}`;
}
export function formatDate(dateString: string): string {
  return format(new Date(dateString), 'MMMM d, yyyy')
}

export function formatDateToMMDDYYYY(dateString: string): string {
  return format(new Date(dateString), 'MM/dd/yyyy')
}

export function checkIfHaveKeyProfiles(postData: Campaign | Blog | null) {
  let haveKeyProfile = false;
  postData?.block?.map((block) => {
    if (block.blockType === 'profileList') {
      block.profileList?.map((profile) => {
        if (profile.keyProfile === true) {
          haveKeyProfile = true;
          return haveKeyProfile;
        }
      })
    }
    else if (block.blockType === 'keyProfileList') {
      haveKeyProfile = true;
      return haveKeyProfile;
    }
  })
  return haveKeyProfile;
}


export async function getPostData<T extends Campaign | Blog>(postCollection: string, postSlug: string, isDraft: boolean, fields?: string) {
  const data: IGraphQLResponse<T, typeof postCollection> = await getCollectionSpecificFields(
    postCollection,
    fields || postDataFields,
    `slug: { equals: "${postSlug}" } `,
    1,
    isDraft,
  ) as IGraphQLResponse<T, typeof postCollection>
  const post: T = data[postCollection].docs[0]

  if (post?.block) {
    post.block = post.block.map((block: any) => {
      switch (block.blockType) {
        case 'regularProfileList':
          if (block.regularHasManyProfileList) {
            block.hasManyProfileList = block.regularHasManyProfileList.map((item: any) => {
              item.value = normalizeProfileValue(item.value)
              return item
            })
          }
          break
        case 'compactProfileList':
          if (block.compactHasManyProfileList) {
            block.hasManyProfileList = block.compactHasManyProfileList.map((item: any) => {
              item.value = normalizeProfileValue(item.value)
              return item
            })
          }
          break
        case 'keyProfileList':
          if (block.keyHasManyProfileList) {
            block.hasManyProfileList = block.keyHasManyProfileList.map((item: any) => {
              item.value = normalizeProfileValue(item.value)
              return item
            })
          }
          break
        case 'profileList':
          if (Array.isArray(block.profileList)) {
            block.profileList = block.profileList.map((entry: any) => {
              if (entry.profile) {
                entry.profile = {
                  ...entry.profile,
                  value: normalizeProfileValue(entry.profile.value),
                }
              }
              return entry
            })
          }
          break
        case 'quotes':
          if (block.profileAuthor && block.profileAuthor.value) {
            block.profileAuthor = {
              ...block.profileAuthor,
              value: normalizeProfileValue(block.profileAuthor.value),
            }
          }
          break
      }
      return block
    })
  }

  return post as T
}



function normalizeProfileValue(value: any): any {
  if (value && typeof value === 'object') {
    // Map aliased profileImage fields back to profileImage
    if ('legacyProfileImage' in value && !('profileImage' in value)) {
      value.profileImage = value.legacyProfileImage
    }
    if ('publicProfileImage' in value && !('profileImage' in value)) {
      value.profileImage = value.publicProfileImage
    }
    // Surface region from nested profileEntity if present
    if (!('region' in value) && value.profileEntity && typeof value.profileEntity === 'object') {
      if ('region' in value.profileEntity) {
        value.region = value.profileEntity.region
      }
    }
  }
  return value
}